import { selectors } from '@sloyd/store-base';
import { delay, select } from 'saga-ts';
import { invokeEvent } from 'shared-base';

// ================== projects ==================
export function* navToProject(id: string) {
  if (!id) return;

  yield delay(100);

  invokeEvent('nav', { path: `/editor/${id}` });
}

export function* navToCurrentProject() {
  const projectId = yield* select(selectors.single.$currentProjectId);
  yield navToProject(projectId);
}

export function* navToPlayground() {
  const playground = yield* select(selectors.base.$playground);
  if (!playground) return;
  yield navToProject(playground.id);
}

// ============ models ============

export function* navToModel(id: string) {
  yield delay(100);
  const projectId = yield* select(selectors.single.$currentProjectId);
  invokeEvent('nav', { path: `/editor/${projectId}/${id}` });
}

export function* navToNewModel() {
  yield navToModel('new-model');
}
